import React from 'react';
import HomeLayout from '../components/home/home-layout';
import {HomeVoice} from '../components/home/home-voice';

const HomeVoicePage: React.FC = () => {
  return (
     <HomeLayout children={<HomeVoice bottomPanel={false} />}></HomeLayout>
  );
};

export default HomeVoicePage;